import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import APIS from "../../../constant/Endpoint";
import usePostHook from "../../../customHooks/usePostHook";
import { validateParty } from "../../../validation/PartyInfo.tsx/Index";
import Button from "../../Reusable/Button";
import ACCOUNTS from "../../../constant/Accounts";
import PartyForm from "../../Customer/PartyForm";

const CreatePartyPopup = (props: any) => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["party"],
    navigateURL: "",
  });

  const { setpartypopup, setParty = null } = props;

  const handleCreate = async (values: any, setError: any) => {
    const url = APIS.CREATE_USER;
    const formData = {
      ...values,
      is_supplier: values?.account === ACCOUNTS.SUNDRY_CREDITORS,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setpartypopup(false);
        if (setParty) {
          setParty("party", res?.data);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const {
    control,
    register,
    setValue,
    getValues,
    clearErrors,
    watch,
    formState: { errors },
    handleSubmit,
    setError,
  } = useForm<any>({
    resolver: yupResolver(validateParty),
  });

  return (
    <div>
      <form
        onSubmit={handleSubmit((data) => handleCreate(data, setError))}
        autoComplete="off"
      >
        <PartyForm
          control={control}
          register={register}
          errors={errors}
          setValue={setValue}
          watch={watch}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <div className={tw`mt-4 w-full px-4 `}>
          <div className={tw`w-32 ml-auto`}>
            <Button label="Create" isLoading={isPostLoading} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreatePartyPopup;

